export default __webpack_public_path__ + "static/media/rent-benefits-img3.64f32290.jpg";